import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'typeof'
})
export class TypeOfpipe implements PipeTransform {

    transform(value: any, args?: any): string {
    return typeof value;
  }

}
